module.exports = __webpack_public_path__ + "img/rearfoot_strike.34cb18a0.svg";